<template>

 <ion-page id="html-page">
   <ion-content >
    <iframe :src="url" :style="styleOneFrame"></iframe>
   </ion-content>
 </ion-page>
</template>

<script setup>

 import { IonItem,IonInput,IonPage, IonContent, modalController } from '@ionic/vue';
 import { doStartupCheck } from '@/composables/startupCheck.js'
 
 import { v4 as uuidv4 } from 'uuid';
 import { watch, onMounted, onBeforeUnmount, onUnmounted, ref } from "vue";
 import ModalErrorMessage from '@/components/ModalErrorMessage.vue'

 import { useConnectionStore } from '@/stores/connectionStore';

 import { useGetData , getLichessData, getChesscomData, 
             generateErrorAlertText } from '@/composables/getData.js'
   import { useWindowSizeStore } from '@/stores/windowSizeStore';
   import { availableWidthHeight, calculateChessBoardRect, isScreenPortraitOrientation } from '@/composables/screenSize'

  const props = defineProps({
    url : {
      type : String,
      default : "https://www.chessvisai.com/"
    }
  })
  const connectionStore = useConnectionStore()
  const isDark = ref(connectionStore.getDarkmode != "light")


  const cookie = connectionStore.getCookie
  const dummy = connectionStore.getDummy

  const encodedCookie = encodeURIComponent(cookie)
  const encodedDummy = encodeURIComponent(dummy)

  // add the uuid to force reload 
  const uuid = uuidv4().replace(/-/g,"")
  const url = ref(props.url + "&c=" + encodedCookie + "&d=" + encodedDummy)
  //const url = ref(props.url + "&c=" + encodedCookie + "&d=" + encodedDummy + "&uuid=" + uuid)
  //const url = ref(props.url)

  console.log("VERBAL URL",url)

  const menuTrigger = ref(0)

  const windowSizeStore = useWindowSizeStore()
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                       height : windowSizeStore.getWindowSize['height'] })

  const preferenceTrigger = ref(0)
  const preferenceAction = ref({})

  var preferenceSetCurrentIndex = 0
  var preferenceSetArray = []

  const styleOneFrame = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  updateWidthHeights()

  const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

  function afterStartupCallbackRoutine(stuffChanged,errorProgram,errorEntry) {
    if (errorProgram != null)
      openErrorModal(errorProgram,errorEntry)

    updateWidthHeights()
    menuTrigger.value++
  }

  doStartupCheck(false,afterStartupCallbackRoutine)

  onMounted(() => {
      // Request a screen wake lock…
 })

  onBeforeUnmount(() => {
  });
  
  onUnmounted(() => {
 
  })
  
 watch(() => windowSizeStore.getWindowSize, () => {
   windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                     height : windowSizeStore.getWindowSize['height'] }
   updateWidthHeights()
   menuTrigger.value++

 })

 function updateWidthHeights() {

 const availableSpace = availableWidthHeight()

    // don't need room for the toolbar
    const whichMenu = localStorage.getItem("whichMenu")
    const showBigButtons = whichMenu == "buttons" || connectionStore.getShowBigButtons
    var footerHeight = connectionStore.getToolbarHeight
    if (showBigButtons)
      footerHeight = Math.floor(footerHeight * connectionStore.getToolbarScalePercentage / 100.0)

    const oneframePositionTop = availableSpace.topIndent
    const oneframePositionLeft = availableSpace.leftRightIndent + availableSpace.leftIndent
    const oneframeHeight = availableSpace.height - oneframePositionTop + availableSpace.topIndent + footerHeight
    const oneframeWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    styleOneFrame.value.height = oneframeHeight + "px"
    styleOneFrame.value.width = oneframeWidth + "px"
    styleOneFrame.value.top = oneframePositionTop + "px"
    styleOneFrame.value.left = oneframePositionLeft + "px"
}

</script>

<style scoped>


</style>
